import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'material-symbols';
import "./assets/css/themify-icons.css";
// import "./assets/scss/paper-kit.scss";
import "./assets/demo/demo.css";

import { LandingPage, Home, GlobalAmbasador } from "./containers/pages";

const App = () => {
  return (
    <Router>
      <Switch>
        {/* Halaman utama */}
        <Route exact path="/" component={LandingPage} />

        {/* Redirect ke #register */}
        <Route
          path="/r/"
          component={() => {
            window.location.href = "#register";
            return null;
          }}
        />

        {/* Global Ambassador page */}
        <Route exact path="/:username" component={GlobalAmbasador} />
      </Switch>
    </Router>
  );
};

export default App;
